import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f42542f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-smo-mode-badge success-badge" }
const _hoisted_2 = { class: "nge-smo-hint success-hint" }
const _hoisted_3 = {
  key: 0,
  class: "nge-smo-combo"
}
const _hoisted_4 = { class: "nge-smo-combo-count" }
const _hoisted_5 = { class: "nge-smo-combo-msg" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-mode-badge split-badge" }, " SPLIT MODE ", -1 /* HOISTED */))
const _hoisted_7 = { class: "nge-smo-groups" }
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-dot red-dot" }, null, -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-label" }, "RED", -1 /* HOISTED */))
const _hoisted_11 = { class: "nge-smo-group-count" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-divider" }, "|", -1 /* HOISTED */))
const _hoisted_13 = ["title"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-dot blue-dot" }, null, -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-group-label" }, "BLUE", -1 /* HOISTED */))
const _hoisted_16 = { class: "nge-smo-group-count" }
const _hoisted_17 = {
  key: 0,
  class: "nge-smo-actions"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-key-hint" }, [
  /*#__PURE__*/_createElementVNode("kbd", null, "G"),
  /*#__PURE__*/_createTextVNode(" Swap")
], -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-key-hint" }, [
  /*#__PURE__*/_createElementVNode("kbd", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" Submit")
], -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Esc", -1 /* HOISTED */))
const _hoisted_21 = {
  key: 1,
  class: "nge-smo-loading-indicator"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-spinner" }, null, -1 /* HOISTED */))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-mode-badge merge-badge" }, " MERGE MODE ", -1 /* HOISTED */))
const _hoisted_25 = {
  key: 0,
  class: "nge-smo-actions"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-key-hint" }, [
  /*#__PURE__*/_createElementVNode("kbd", null, "Ctrl+Click"),
  /*#__PURE__*/_createTextVNode(" Set points")
], -1 /* HOISTED */))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-key-hint" }, [
  /*#__PURE__*/_createElementVNode("kbd", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" Submit")
], -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Esc", -1 /* HOISTED */))
const _hoisted_29 = {
  key: 1,
  class: "nge-smo-loading-indicator"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-smo-spinner" }, null, -1 /* HOISTED */))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "nge-smo-result-icon" }
const _hoisted_33 = { class: "nge-smo-result-text" }
const _hoisted_34 = {
  key: 0,
  class: "nge-smo-inline-combo"
}
const _hoisted_35 = {
  key: 1,
  class: "nge-smo-result-retry"
}
const _hoisted_36 = {
  key: 0,
  class: "nge-smo-split-burst"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-burst-ring nge-smo-burst-ring--1" }, null, -1 /* HOISTED */))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-burst-ring nge-smo-burst-ring--2" }, null, -1 /* HOISTED */))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-smo-burst-ring nge-smo-burst-ring--3" }, null, -1 /* HOISTED */))
const _hoisted_40 = [
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = {
  key: 1,
  class: "nge-smo-particles"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "overlay-slide" }, {
      default: _withCtx(() => [
        ($setup.isVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["nge-split-merge-overlay", {
        multicut: $setup.isMulticut && !$setup.isPendingClose,
        merge: $setup.isMerge && !$setup.isPendingClose,
        submitting: $setup.isSubmitting,
        'bar-success': $setup.isPendingClose && $setup.resultIsSuccess,
        'bar-error': $setup.isPendingClose && $setup.resultIsError,
        'bar-inline-success': $setup.hasInlineResult && $setup.resultIsSuccess,
        'bar-inline-error': $setup.hasInlineResult && $setup.resultIsError,
      }])
            }, [
              _createCommentVNode(" SUCCESS / ERROR CLOSE STATE — replaces normal content "),
              ($setup.isPendingClose)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_1, _toDisplayString($setup.resultIsSuccess ? 'SUCCESS' : 'ERROR'), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.store.resultText), 1 /* TEXT */),
                    ($setup.resultIsSuccess && $setup.combo > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.combo) + "×", 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_5, _toDisplayString($setup.comboMessage), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : ($setup.isMulticut)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createCommentVNode(" MULTICUT / SPLIT MODE "),
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-smo-group red", { active: $setup.isRedActive }]),
                          onClick: _cache[0] || (_cache[0] = $event => (!$setup.isRedActive && $setup.swapGroup())),
                          title: $setup.isRedActive ? 'Red group (active)' : 'Click to switch to Red'
                        }, [
                          _hoisted_9,
                          _hoisted_10,
                          _createElementVNode("span", _hoisted_11, _toDisplayString($setup.store.redPointCount) + " pt" + _toDisplayString($setup.store.redPointCount !== 1 ? 's' : ''), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_8),
                        _hoisted_12,
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-smo-group blue", { active: $setup.isBlueActive }]),
                          onClick: _cache[1] || (_cache[1] = $event => (!$setup.isBlueActive && $setup.swapGroup())),
                          title: $setup.isBlueActive ? 'Blue group (active)' : 'Click to switch to Blue'
                        }, [
                          _hoisted_14,
                          _hoisted_15,
                          _createElementVNode("span", _hoisted_16, _toDisplayString($setup.store.bluePointCount) + " pt" + _toDisplayString($setup.store.bluePointCount !== 1 ? 's' : ''), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_13)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["nge-smo-hint", { 'error-hint': $setup.hasInlineResult && $setup.resultIsError }])
                      }, _toDisplayString($setup.contextHint), 3 /* TEXT, CLASS */),
                      (!$setup.isSubmitting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("button", {
                              class: "nge-smo-action-btn clear-btn",
                              onClick: $setup.clearPoints,
                              title: "Clear all points"
                            }, "Clear"),
                            _hoisted_18,
                            _hoisted_19,
                            _createElementVNode("button", {
                              class: "nge-smo-action-btn cancel-btn",
                              onClick: $setup.cancelTool,
                              title: "Exit split mode"
                            }, [
                              _hoisted_20,
                              _createTextVNode(" Cancel")
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      ($setup.isSubmitting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : ($setup.isMerge)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createCommentVNode(" MERGE MODE "),
                        _hoisted_24,
                        _createElementVNode("div", {
                          class: _normalizeClass(["nge-smo-hint merge-hint", { 'error-hint': $setup.hasInlineResult && $setup.resultIsError }])
                        }, _toDisplayString($setup.contextHint), 3 /* TEXT, CLASS */),
                        (!$setup.isSubmitting)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _hoisted_26,
                              _hoisted_27,
                              _createElementVNode("button", {
                                class: "nge-smo-action-btn cancel-btn",
                                onClick: $setup.cancelTool,
                                title: "Exit merge mode"
                              }, [
                                _hoisted_28,
                                _createTextVNode(" Cancel")
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        ($setup.isSubmitting)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Holographic result flash — inline (merge stays open) or split success "),
    _createVNode(_Transition, { name: "flash-pop" }, {
      default: _withCtx(() => [
        ($setup.hasInlineResult || ($setup.isPendingClose && $setup.resultIsSuccess))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["nge-smo-result-flash", {
             success: $setup.resultIsSuccess,
             error: $setup.resultIsError,
             'split-success': $setup.isPendingClose && $setup.resultIsSuccess && $setup.isMulticut,
           }])
            }, [
              _createElementVNode("span", _hoisted_32, _toDisplayString($setup.resultIsSuccess ? '✓' : '✗'), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_33, _toDisplayString($setup.store.resultText), 1 /* TEXT */),
              ($setup.resultIsSuccess && $setup.combo > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString($setup.combo) + "× " + _toDisplayString($setup.comboMessage), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.resultIsError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Press Enter to retry"))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Split success energy burst (expanding rings + particles) "),
    ($setup.isPendingClose && $setup.resultIsSuccess && $setup.isMulticut)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_40))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Success particles "),
    ($setup.showParticles)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (i) => {
            return _createElementVNode("span", {
              key: i,
              class: "nge-smo-particle",
              style: _normalizeStyle({ '--angle': (i * 18) + 'deg', '--speed': (0.6 + Math.random() * 0.8) + 's', '--dist': (40 + Math.random() * 80) + 'px' })
            }, null, 4 /* STYLE */)
          }), 64 /* STABLE_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}